export default "__VITE_ASSET__BinG3cfA__"